import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manager';

const list = (merchantId) => {
	return Client.get(`${baseUrl}/${merchantId}/merchantContactMains`);
};

const find = (merchantId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/merchantContactMains/${id}`);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/merchantContactMains`, payload);
};

const update = (merchantId, id, payload) => {
	return Client.put(
		`${baseUrl}/${merchantId}/merchantContactMains/${id}`,
		payload
	);
};

const remove = (merchantId, id) => {
	return Client.del(`${baseUrl}/${merchantId}/merchantContactMains/${id}`);
};

export default {
	list,
	find,
	create,
	update,
	remove,
};
